import { Descriptions, Select } from "antd";
import moment from "moment";
import { FC, useEffect, useState } from "react";
// import { CgCloseR } from "react-icons/cg";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";
import useNotification from "../../../hooks/useNotification";
import { IFaq } from "../../../models/boardFaq.model";
import { RootState } from "../../../store/rootReducer";
import Button from "../../Button";
// import FileUpload from "../../FileUpload";
import Tinymce from "../../Tinymce";

export interface IProps {
  data?: IFaq;
  submit: (data: FormData) => void;
}

const FaqEditor: FC<IProps> = ({
  data, submit
}) => {
  const { t } = useTranslation();
  const { writeAuthYn } = useAuth();
  const history = useHistory();
  const location = useLocation();
  const { infoNotification } = useNotification();
  const { auth } = useSelector((state: RootState) => state.auth);
  const { serverDate } = useSelector((state: RootState) => state.serverDate);
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // BR0005 = FAQ 카테고리
  const BR0005 = commonCodes.find(item => item.commonCode === 'BR0005')?.detailCode;

  const [title, setTitle] = useState('');
  const [faqDiv, setFaqDiv] = useState<string>();
  const [content, setContent] = useState('');
  const [files,] = useState<any>([null]);
  const [isCreate, setIsCreate] = useState(true);
  const [faqFiles, setFaqFiles] = useState<any>([]);
  const [readCount, setReadCount] = useState(0);

  useEffect(() => {
    if (data) {
      setTitle(data.title);
      setFaqDiv(data.faqDiv);
      setContent(data.content);
      setFaqFiles(data.faqFiles);
      setReadCount(data.readCount);
      setIsCreate(false);
    }
  }, [data]);
  
  // const onSetFile = (index: number, file: any) => {
  //   const _files = [...files];
  //   _files[index] = file;
  //   setFiles(_files);
  // }

  // const onAddFile = () => {
  //   const _files = [...files];
  //   _files.push(null);
  //   setFiles(_files);
  // }

  // const onDeleteFile = (index: number) => {
  //   const _files = [...files];
  //   _files.splice(index, 1);
  //   setFiles(_files);
  // }

  // const onDeleteAttachedFile = (index: number) => {
  //   const _faqFiles = [...faqFiles];
  //   _faqFiles[index].originalName = null;
  //   setFaqFiles(_faqFiles);
  // }

  const onSubmit = () => {
    if (!title) {
      return infoNotification(t('homepage.archive.message1'));
    }
    if (!faqDiv) {
      return infoNotification(t('homepage.faq.message1'));
    }
    if (!content) {
      return infoNotification(t('homepage.archive.message4'));
    }

    const form = new FormData();
    form.append('title', title);
    form.append('faqDiv', faqDiv);
    form.append('content', content);

    if (isCreate) {
      /* 생성 시 파일 처리 */
      if (files.length > 0) {
        files.forEach((item: any) => {
          if (item !== null) form.append('files', item);
        });
      }
    } else {
      /* 수정 시 파일 처리 */
      if (data?.faqFileCode) {
        form.append('faqFileCode', String(data.faqFileCode));
      }

      if (faqFiles) {
        // 기존 첨부파일 있음
        let hasNewFiles = false;
        files.forEach((item: any) => {
          if (item) hasNewFiles = true;
        });

        let isAllDeleted = true;
        let hasDeleted = false;
        faqFiles.forEach((item: any) => {
          if (item.originalName) {
            isAllDeleted = false;
          } else {
            hasDeleted = true;
            form.append('faqDeleteFiles', item.fileSeq);
          }
        });

        if (hasNewFiles) form.append('faqFileStatus', 'update');
        else if (isAllDeleted) form.append('faqFileStatus', 'delete');
        else if (hasDeleted) form.append('faqFileStatus', 'update');
        else form.append('faqFileStatus', 'keep');
      } else {
        // 기존 첨부파일 없음
        if (files.length > 0 && files[0] !== null) {
          // 추가 첨부파일 있음
          form.append('faqFileStatus', 'create');
        } else {
          // 추가 첨부파일 없음
          form.append('faqFileStatus', 'keep');
        }
      }

      if (files.length > 0) {
        files.forEach((item: any) => {
          if (item !== null) form.append('faqNewFiles', item);
        });
      }
    }

    submit(form);
  }

  return (
    <div className='comm-table__area rowType'>
      <Descriptions
        bordered
        column={4}
        size="small"
        labelStyle={{ width: '12.5%' }}
        contentStyle={{ width: '12.5%' }}
      >
        <Descriptions.Item label={`* ${t('common.column.title')}`} span={4}>
          <input
            type="text"
            className="form-control"
            value={title}
            onChange={e => setTitle(e.target.value)}
          />
        </Descriptions.Item>
        <Descriptions.Item label={`* ${t('homepage.education.column1')}`}>
          <div className="w-150p">
            <Select
              className="w-100"
              placeholder={t('common.button.select')}
              value={faqDiv}
              onChange={value => setFaqDiv(value)}
            >
              {BR0005?.map(item => (
                <Select.Option
                  key={item.detailCode}
                  value={item.detailCode}
                >
                  {item.korName}
                </Select.Option>
              ))}
            </Select>
          </div>
        </Descriptions.Item>
        <Descriptions.Item label={t('common.column.writer')}>
          {auth?.korName}
        </Descriptions.Item>
        <Descriptions.Item label={t('homepage.archive.column8')}>
          {moment(serverDate).format('YYYY.MM.DD')}
        </Descriptions.Item>
        <Descriptions.Item label={t('homepage.archive.column7')}>
          {readCount}
        </Descriptions.Item>
        <Descriptions.Item label={`* ${t('common.column.contents')}`} span={4}>
          <Tinymce
            content={content}
            setContent={setContent}
          />
        </Descriptions.Item>
        {/* {
          faqFiles?.length
            ? (
              <Descriptions.Item label="기존 첨부파일" span={4}>
                {
                  faqFiles.map((item: any, index: number) => {
                    return item?.originalName
                      ? (
                        <div>
                          <a
                            className="download-link"
                            href={`${item.fileLocation}`}
                            download={item.originalName}
                          >
                            {item.originalName}
                          </a>
                          <span
                            className="ml-1 pointer"
                            onClick={() => onDeleteAttachedFile(index)}
                          >
                            <CgCloseR />
                          </span>
                        </div>
                      )
                      : null;
                  })
                }
              </Descriptions.Item>
            )
            : null
        }
        <Descriptions.Item label={isCreate ? '첨부파일' : '추가 첨부파일'} span={4}>
          {
            files.length > 0
              ? files.map((file: any, index: number) => (
                <div className="flex mb-2" key={index}>
                  <FileUpload
                    file={files[index]}
                    setFile={(file: any) => onSetFile(index, file)}
                  />
                  <div className="pr-t1">
                    <Button
                      className="btn btn-info ml-1"
                      onClick={() => onDeleteFile(index)}
                      text="삭제"
                    />
                  </div>
                </div>
              ))
              : null
          }
          <Button
            className="btn btn-success btn-w100p"
            onClick={onAddFile}
            text="추가"
          />
        </Descriptions.Item> */}
      </Descriptions>

      <div className="comm-bx__space">
        <div className="comm-btn__area right">
          <Button
            onClick={onSubmit}
            className="btn-basic pink"
            text={t('common.button.save')}
            writeAuthYn={writeAuthYn}
          />
          <Button
            onClick={() => history.push(`/homepage/faq${location.search}`)}
            className="btn-basic gray"
            text={t('common.button.cancel')}
          />
        </div>      
      </div>
    </div>
  );
}

export default FaqEditor;
